import Input from './fields/Input';
import Select from './fields/Select';
import TextArea from './fields/TextArea';

export default {
	Input,
	Select,
	TextArea,
};
